import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ConfigProvider } from "antd";
import { AuthProvider } from "./contexts/AuthContextProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        components: {
          Collapse: {
            headerBg: "rgba(0, 0, 0, 0)",
          },
          Tag: {
            defaultBg: "#44469010",
            defaultColor: "rgba(68, 70, 144, 1)",
          },
          Menu: {
            itemHeight: 55,
            // itemHoverBg: "rgba(68, 70, 144, 1)",
          },
        },
      }}
    >
      <AuthProvider>
        <App />
      </AuthProvider>
    </ConfigProvider>
  </React.StrictMode>
);

reportWebVitals();
